export default __webpack_public_path__ + "static/media/present-a-new-business-idea.c05cb97a.svg";